<script setup lang="ts">
const props = defineProps<{ topic: string }>();
const icons: Record<string, [string, string]> = {
  birthday: ['i-lucide-cake', 'peach'], love: ['i-lucide-heart', 'rose'],
  wedding: ['i-lucide-gem', 'rose'], anniversary: ['i-lucide-gift', 'peach'],
  funny: ['i-lucide-smile', 'peach'], diss: ['i-lucide-flame', 'rose'],
  youtube: ['i-lucide-clapperboard', 'blue'], podcast: ['i-lucide-mic', 'blue'],
  tiktok: ['i-lucide-video', 'blue'], game: ['i-lucide-gamepad-2', 'blue'],
  rap: ['i-lucide-mic-vocal', 'lilac'], pop: ['i-lucide-disc-3', 'lilac'],
  country: ['i-lucide-guitar', 'peach'], rock: ['i-lucide-zap', 'rose'],
  anime: ['i-lucide-sparkles', 'lilac'], lofi: ['i-lucide-headphones', 'mint'],
  jazz: ['i-lucide-music-2', 'peach'], edm: ['i-lucide-audio-lines', 'lilac'],
  royaltyFree: ['i-lucide-badge-check', 'mint'], commercial: ['i-lucide-briefcase-business', 'mint'],
  occasions: ['i-lucide-gift', 'peach'], creators: ['i-lucide-clapperboard', 'blue'],
  genres: ['i-lucide-disc-3', 'lilac'], projects: ['i-lucide-badge-check', 'mint'],
};
const icon = computed(() => icons[props.topic] || ['i-lucide-music-2', 'lilac']);
</script>

<template>
  <span class="discovery-icon" :class="`discovery-icon--${icon[1]}`" aria-hidden="true">
    <span :class="icon[0]" />
  </span>
</template>

<style scoped>
.discovery-icon { display: inline-flex; align-items: center; justify-content: center; flex: none; width: 44px; height: 44px; border-radius: 12px; color: var(--topic-ink); background: var(--topic-surface); }
.discovery-icon > span { width: 23px; height: 23px; }
.discovery-icon--peach { --topic-ink: #fbc9a9; --topic-surface: #332622; }
.discovery-icon--rose { --topic-ink: #f3acc4; --topic-surface: #34222e; }
.discovery-icon--blue { --topic-ink: #a7c9ff; --topic-surface: #202d42; }
.discovery-icon--lilac { --topic-ink: #ccbdff; --topic-surface: #2c2541; }
.discovery-icon--mint { --topic-ink: #a5e4cb; --topic-surface: #1f332f; }
</style>
